import { CreateTicket } from "components/Ticket/CreateTicket";
import { useAppSelector } from "hooks/useAppSelector";
import { useRoleBasedView } from "hooks/useRoleBasedView";
import { useDispatch } from "react-redux";
import { useGetTaskFromChannelIdQuery } from "store/apis/task";
import { closeCreateChatTicketModal } from "store/slices/ticket";
import { useChannelStateContext } from "stream-chat-react";

export const ChatTicketModal = () => {
  const dispatch = useDispatch();
  const { canManageInternalTickets } = useRoleBasedView();
  const { channel } = useChannelStateContext();

  const { data: channelTask } = useGetTaskFromChannelIdQuery(
    {
      channelId: channel.id!,
    },
    {
      skip: !channel.id,
      refetchOnMountOrArgChange: true,
    }
  );

  const { entity, company_group, tasks } = channelTask || {};
  const { uuid: currentEntityUuid } = entity || {};
  const { uuid: taskGroupId } = company_group || {};
  const groupId = (channel.data?.group_uuid as string) || taskGroupId;

  const { showCreateTicketModal, chatContext } = useAppSelector(
    (state) => state.ticket.createTicketData
  );

  if (canManageInternalTickets && showCreateTicketModal) {
    return (
      <CreateTicket
        isNonChatTicket={false}
        show={showCreateTicketModal}
        currentEntityUuid={currentEntityUuid}
        channelId={channel.id}
        groupId={groupId}
        closeModal={() => dispatch(closeCreateChatTicketModal())}
        taskId={tasks?.[0]?.uuid}
        chatContext={chatContext}
      />
    );
  }
  return null;
};
